import { Box, Typography } from "@braintrust/braintrust-ui-components";
import { useFreelancerProfile } from "@js/apps/freelancer/hooks";

import { useCurrentFreelancerProfileCompletion } from "../../hooks/use-current-freelancer-profile-completion";
import { ProfileCompletionFeedback } from "../profile-completion/feedback";
import { ProgressBarNudge } from "../progress-bar-nudge";

import styles from "./style.module.scss";

export const NavigationProfileCompletionNudgeCard = () => {
  const freelancerProfile = useFreelancerProfile();
  const canBid = freelancerProfile?.can_bid;

  const { data: profileCompletion, isProfileCompleted } =
    useCurrentFreelancerProfileCompletion({
      skip: canBid,
    });

  if (
    !freelancerProfile ||
    !profileCompletion ||
    canBid ||
    isProfileCompleted
  ) {
    return null;
  }

  return (
    <Box className={styles.profileCompletionNavCard}>
      <Typography
        component="p"
        variant="paragraph"
        size="medium"
        fontWeight={400}
        color="white"
        sx={{ mb: 2 }}
      >
        Your profile is {profileCompletion.completion_percent}% complete
      </Typography>
      <ProgressBarNudge
        value={profileCompletion.completion_percent}
        darkProgressBar
        sx={{ height: "13px" }}
      />
      <Typography
        component="p"
        color="white"
        style={{ fontSize: "11px", lineHeight: "17px", margin: "12px 0" }}
      >
        Complete your profile to apply for jobs and go through our Braintrust
        Approved Talent screening.
      </Typography>
      <ProfileCompletionFeedback missingAreas={profileCompletion.missing} />
    </Box>
  );
};
